// src/config/booking.ts
// Medicasimple klinik yönetim sisteminden alınan online randevu linki -
// hastalar buraya tıklayınca doğrudan Medicasimple'ın randevu akışına
// (tedavi seçimi -> doktor seçimi -> gönder) yönleniyor.
export const MEDICASIMPLE_BOOKING_URL =
  "https://klinik.medicasimple.com/online-randevu/eyJpZCI6MTQzLCJxIjoibWVkaWNhc2ltcGxlXzIyIiwiZGVmYXVsdExhbmd1YWdlIjoidHIifQ%3D%3D";
